import { ReactNode } from 'react';

import { IncomeStatementsListParamsProvider } from './income-statements-list-params-provider';

export const AppProvider = ({ children }: { children: ReactNode }) => {
  return <IncomeStatementsListParamsProvider>{children}</IncomeStatementsListParamsProvider>;
};
